import { render } from "./RoleDistributionCard.vue?vue&type=template&id=46f07a52&scoped=true"
import script from "./RoleDistributionCard.vue?vue&type=script&lang=js"
export * from "./RoleDistributionCard.vue?vue&type=script&lang=js"

import "./RoleDistributionCard.vue?vue&type=style&index=0&id=46f07a52&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f07a52"]])

export default __exports__